import { Router } from 'aurelia-router';
import { bindable, computedFrom, autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import * as moment from 'moment';
import numeral from 'numeral';
import { PayrazrService } from '../../services/payrazr';
import { State } from '../../services/global-state';
import { Offer } from '../../models/offer';
import { HpfCustomerService, MakeOfferResponse } from '../../services/hpf-customer.service';
import { Account } from '../../models/customer';
import { PaymentItemTableConfiguration } from '../../smart/models/payment-item-table-configuration';

@autoinject
export class ContactMe {
	validationErrors: string[];
	isSubitting: boolean = false;
	account: Account;
	businessKey;
	contact: Contact = new Contact();

	constructor(private router: Router, private globalState: State, private payrazrService: PayrazrService, private hpfCustomerService: HpfCustomerService, private i18n: I18N) {
	}

	activate(params, routeData) {
		if (routeData.accountId) {
			this.account = this.globalState.accounts.find((element, index, array) => {
				return element.id === routeData.accountId;
			});
		}

		this.businessKey = this.globalState.business.key;
	}

	submit() {
		this.validate();
		if (this.validationErrors.length === 0) {
			this.hpfCustomerService.sendContactMeRequest(this.account.customerAccountKey, this.contact.name, this.contact.email, this.contact.phone, this.contact.tddtty).then(
				(result) => {
					alert(this.i18n.i18next.t('weWillContactYouWithinTwoBusinessDaysAtTheEmailPhoneProvided', 'We will contact you within 2 business days at the email or phone number you provided.'));
					this.router.navigateToRoute('secure');
				},
				(error) => {
					this.validationErrors.push(this.i18n.i18next.t('anErrorOccuredSubmittingRequest', 'An error occured while submitting your request.'));
					console.error(error);
				}
			);
		}
	}

	validate() {
		this.validationErrors = [];

		if (!this.contact.name) {
			this.validationErrors.push(this.i18n.i18next.t('nameRequired', 'Name is required'));
		}

		if (!this.contact.email && !this.contact.phone) {
			this.validationErrors.push(this.i18n.i18next.t('pleaseEnterEmailOrPhoneNumber', 'Please enter an email address or phone number'));
		}

		// Verify the format from the phone number component: '(123) 456-7890'
		if (!/.*\d{3}.*\d{3}.*\d{4}/.test(this.contact.phone)) {
			this.validationErrors.push(this.i18n.i18next.t('phoneNumberDigitsVerification', 'Phone number must be 10 digits'));
		}
	}

}

class Contact {
	name: string;
	email: string;
	phone: string;
	tddtty: boolean;
}
